app.service('deliveryShops', function (console, orderConfig, modal, scroll, saveDeliveryData) {
	var config; var savedCallback;

	function refresh(params, callback) {
		if (callback) {
			savedCallback = callback;
		}
		config = orderConfig.getData();

		var data = {
			city: config.cityCode,
			store_code: config.shopCode,
			location: config.location,
			filtered: config.hasOnlySmall,
			lastOrderShopCode: config.lastOrderShopCode,
			orderNumber: config.orderNumber,
			taxfree: config.deliveryInfo && config.deliveryInfo.taxfree ? config.deliveryInfo.taxfree : undefined
		};

		$.extend(true, data, params);
		$.ajax({
			url: '/orderSelectShop.ltr',
			data: data,
			success: function (html) {
				savedCallback(html, data, params);
			},
			error: function () {
				modal.alert('Błąd pobierania danych sklepów, spróbuj ponownie.');
			}
		});
	}
	function refreshSuccess() {
		config.lastOrderShopCode = false;
		if ($('input[name="paymentType"][value="5"]:checked').length) {
			$('#shops-list').addClass('delivery-time-not-changeable');
		}
	}
	var savedShop = '';
	function selectCityParams(cityCode) {
		if (cityCode !== '') {
			savedShop = config.shopCode !== '' ? config.shopCode : savedShop;
			return {
				city: cityCode,
				store_code: savedShop
			};
		}
	}
	function findNearParams(position) {
		return {
			city: '',
			latitude: position.latitude,
			longitude: position.longitude
		};
	}
	function selectLocation(location) {
		console.log('WYBRANIE SKLEPU - ' + location.shop + ' | ' + location.city);
		if ($('#shop-code').length) {
			$('#shop-code').val(location.shop).valid();
		}
		if ($('#city-code').length) {
			$('#city-code').val(location.city).valid();
		}
		if ($('#shop-delivery').length) {
			if (config.shopCode == location.shop && config.cityCode == location.city) {
				$('#container').addClass('hide-shops').removeClass('edit-shop');
				//$('#preview-order-steps .row-delivery-point').show();
				scroll.to({ $element: $('#short-delivery-address-data .row-delivery-point') });
			} else {
				saveDeliveryData.send({
					pickupPointType: 'SHOP',
					pickupPointCode: location.shop,
					cityCode: location.city
				}, function (isSaving) {
					config.shopCode = location.shop;
					config.cityCode = location.city;
					$('#short-delivery-address-data').html($('#preview-order-steps .row-delivery-point')[0].outerHTML);
					$('#container').addClass('hide-shops').removeClass('edit-shop');
					$('#preview-order-steps .row-delivery-point').show();
					scroll.to({ $element: $('.row-delivery-point') });
					refresh({
						lastOrderShopCode: false
					});
				}, function () {
					modal.alert('Błąd zapisania wybranego sklepu. Spróbuj ponownie.');
				});
			}
		} else {
			config.shopCode = location.shop;
			config.cityCode = location.city;
		}
	}

	return {
		refresh,
		refreshSuccess,
		selectCityParams,
		findNearParams,
		selectLocation
	};
});
